import { render, staticRenderFns } from "./sfc-search.vue?vue&type=template&id=7681f1cc&lang=pug&"
import script from "./sfc-search.vue?vue&type=script&lang=js&"
export * from "./sfc-search.vue?vue&type=script&lang=js&"
import style0 from "./sfc-search.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports